module.exports = __webpack_public_path__ + "static/media/3.4197a090.png";